var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmapiiWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 809.9 158",
    style: {
      enableBackground: "new 0 0 809.9 158"
    },
    fill: "#fcfcfc",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M81.9,8.9L33.8,138.1c-3.7,9.3-9.7,11.3-14.2,11.3H6.1L56.9,19.7c2.4-5.5,3.8-8.6,14.1-10.8L81.9,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M78,76.4l-6.3,17.2h42.1l-16.1,5.5L113,139c3.6,8.4,8.4,10.4,26.7,10.4l-23.4-59.5 c-3.5-10.3-9.9-13.4-17.5-13.4L78,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M183.7,149.4V24.7c0.4-10.6,8.7-16.6,19.4-15.9l57,140.5h-13.9c-8,0-11.7-5-13.9-10.8l-35.6-97l7.7,34.9V133 C204.6,141.8,199.9,150.3,183.7,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M272,125.4L260.5,96l34-87.2c12.4-0.6,20.5,4.2,20.6,15.7v124.8c-12.2,0.1-20.4-7.2-20.6-17V85l8.4-43.1 L272,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M417,8.6l48.1,129.2c3.7,9.3,9.7,11.3,14.2,11.3h13.5L442,19.4c-2.4-5.5-3.8-8.6-14.1-10.8L417,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M420.9,76.2l6.3,17.2H385l16.1,5.5l-15.2,39.8c-3.6,8.4-8.4,10.4-26.7,10.4l23.4-59.5 c3.5-10.3,9.9-13.4,17.5-13.4L420.9,76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M558,99.1v50.3c-14,0.5-21.1-6.9-21.1-16.2V88.6c0.6-10.4,6.1-16.1,15.6-16.5h33.4c8.5-0.3,18.5-6.5,19.1-19.7 c1.1-11.8-8-21.6-19.3-22.1h-48.9v-5.6c0-4.9,1.2-14.4,15.6-15.8h33.2c15.5,0.5,29.6,9.4,36.2,22.7c10.7,20.2,0,39.8,0,39.8 c-7.5,11.8-17.7,21-36.2,22.4h-41.8L558,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M785.2,31.1h-13.4l25.6,118.3c-13.4,0.3-22.7-2.7-25.9-14.1L750.9,39l15.2-7.9h-0.4h-95 C669.9,19,674.6,10.5,689.6,9h114.3C804.3,22.8,798.6,30.7,785.2,31.1z M689.2,149.4c12.3,0.3,22.2-5.4,22.2-19.7V49.4h-22.2V149.4 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmapiiWhite);
export default __webpack_public_path__ + "static/media/amapii-white.c5e0c68c3fb336a03e4148220deb2a4b.svg";
export { ForwardRef as ReactComponent };